<template>
  <footer
    id="footer"
    class="footer is-transparent columns is-centered is-multiline"
  >
    <div class="column">
      <div class="column">
        <ul class="list">
          <li class="item" v-for="item in menu" :key="item.key">
            <LangSwitch v-if="item.key === 'lang'" />
            <router-link v-else :to="item.link">{{
              capitalize($t(item.key))
            }}</router-link>
            <span class="soon" v-if="item.isSoon"></span>
          </li>
        </ul>
      </div>
      <div class="column">
        <ul style='display: flex; flex-wrap: wrap; justify-content: center;'>
          <li class="social" v-for="social in socials" :key="social.social">
            <a :href="social.link" target="_blank">
              <span class="icon">
                <TelegramIcon  v-if='social.social==="telegram"' width="28" height="28" :isColor="false"/>
                <FacebookIcon  v-if='social.social==="facebook"' width="28" height="28"/>
                <XTwitterIcon v-if='social.social==="x-twitter"'/>
                <InstagramIcon v-if='social.social==="instagram"'/>
              </span>
              <span>{{ social.social }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="column">
        <ul class="apps">
          <li v-for="app in apps" :key="app.key">
            <component
              :is="app.link ? 'a' : 'span'"
              class="app-badge"
              :class="{ 'is-soon': !app.link }"
              :href="app.link || null"
              :target="app.link ? '_blank' : null"
              :rel="app.link ? 'noopener' : null"
              :title="app.link ? null : 'Coming soon'"
            >
              <span class="app-badge__icon">
                <AppleIcon v-if="app.key === 'ios'" />
                <GooglePlayIcon v-else />
              </span>
              <span class="app-badge__text">
                <span class="app-badge__caption">{{ $t(app.captionKey) }}</span>
                <span class="app-badge__store">{{ app.store }}</span>
              </span>
            </component>
          </li>
        </ul>
      </div>
    </div>
    <div class="column is-multiline">
      <div class="column footer-text low" v-html="$t('footer_desc')"></div>
      <div class="column footer-text">Powered by DAD.BET</div>
      <div class="column footer-text">
        © {{ appName }} {{ year }} {{ $t("all_rights_reserved") }}.
      </div>
    </div>
  </footer>
</template>

<script>
// TODO change column layout
import LangSwitch from "@/components/LangSwitch.vue";
import TelegramIcon from "@/components/common/icons/Telegram.vue"
import FacebookIcon from "@/components/common/icons/Facebook.vue"
import XTwitterIcon from "@/components/common/icons/XTwitter.vue"
import InstagramIcon from "@/components/common/icons/Instagram.vue"
import AppleIcon from "@/components/common/icons/Apple.vue"
import GooglePlayIcon from "@/components/common/icons/GooglePlay.vue"
export default {
  name: "Footer",
  components: {
    LangSwitch,
    TelegramIcon,
    FacebookIcon,
    XTwitterIcon,
    InstagramIcon,
    AppleIcon,
    GooglePlayIcon,
  },
  data: () => ({
    appName: "SCORE68",
    // ссылки на сторы появятся после публикации приложений; пока бейджи
    // показываются неактивными (link: "")
    apps: [
      {
        key: "ios",
        captionKey: "app_download_on",
        store: "App Store",
        link: "",
      },
      {
        key: "android",
        captionKey: "app_get_it_on",
        store: "Google Play",
        link: "",
      },
    ],
    menu: [
      // TODO: move to getters
      {
        key: "live",
        link: "/live",
      },
      {
        key: "prematch",
        link: "/prematch",
      },
      {
        key: "ticker",
        link: "/ticker",
      },
      {
        key: "subscription",
        link: "/subscriptions",
      },
      {
        key: "privacy_policy",
        link: "/privacy_policy",
      },
      {
        key: "terms_and_conditions",
        link: "/terms_and_conditions",
      },
      {
        key: "about_us",
        link: "/about_us",
      },
      {
        key: "contact_us",
        link: "/contact_us",
      },
      {
        key: "lang",
        title: "Language",
        link: "#",
      },
    ],
  }),
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  computed: {
    socials() {
      return this.$store.state.social.list || [];
    },
    year() {
      const startYear = 2022;
      const now = new Date();
      const currentYear = now.getFullYear();
      return `${startYear} - ${currentYear}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../scss/variables" as *;

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 12px;
}

.footer-text {
  text-align: center;
}

.low {
  font-size: 16px;
}

#footer {
  min-height: 10rem;
  padding: 0;
  flex-grow: 3;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: auto;
  order: 0;
  margin: 0;
  font-family: "DINPro Condensed Light", sans-serif;
  font-size: 1.2em;
  background-color: var(--league-body-color);

  & > .column {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    align-content: stretch;

    & > .columns {
      flex-grow: 0;
      flex-shrink: 1;
      flex-basis: auto;
      align-self: auto;

      &:first-child {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: auto;
        align-self: auto;
      }
    }
  }

  ul {
    &.list {
      column-count: 3;
      column-gap: 15%;
      background-color: transparent;
      box-shadow: none;

      @media screen and (max-width: $desktop) {
        column-count: 2;
      }

      @media screen and (max-width: $tablet) {
        column-count: 1;
        text-align: center;
      }
    }

    .item {
      display: flex;
      align-items: flex-start;
      width: 100%;
    }

    .item,
    .social {
      a {
        padding: 0.5rem;
        color: var(--font-color);
        background-color: transparent;

        @media screen and (max-width: $tablet) {
          display: block;
        }

        &:hover {
          background-color: var(--body-color);
        }
      }
    }

    .social {
      a {
        display: inline-flex;
        height: 30px;

        @media screen and (max-width: $tabletMinusTwo) {
          width: 100%;
          justify-content: center;
        }

        .icon {
          display: inline-block;
          margin-right: 0.3rem;
          height: 25px;
          width: 25px;
          svg{
            fill:  var(--font-color);
          }
        }
      }
    }

    &.apps {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px;
      background-color: transparent;
      box-shadow: none;
    }
  }

  .app-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border: 1px solid var(--font-color);
    border-radius: 8px;
    color: var(--font-color);
    background-color: transparent;
    text-decoration: none;
    transition: background-color 0.2s;

    &:hover {
      background-color: var(--body-color);
    }

    // до публикации приложений ссылок нет — бейдж неактивен
    &.is-soon {
      opacity: 0.55;
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }

    &__icon {
      display: inline-flex;
      width: 22px;
      height: 22px;

      svg {
        width: 100%;
        height: 100%;
        fill: var(--font-color);
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      line-height: 1.1;
      text-align: left;
    }

    &__caption {
      font-size: 10px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      opacity: 0.75;
    }

    &__store {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
